/*!

=========================================================
* User Layout for end-user navigation (limited sidebar)
=========================================================

*/
import React from "react";
// react library for routing
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

// core components (reuse admin navbar/footer/sidebar for consistency)
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import ProtectedRoute from "components/ProtectedRoute.js";

import { appRoutes, getSidebarRoutes } from "routes/index.js";
// COMENTADO - Solo usar token de Keycloak, no TokenProvider de Postman
import { ToastProvider } from "contexts/ToastContext.js";

function User() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes) => {
    // Render only valid, internal routes (skip nav-only/hash/external placeholders)
    return routes
      .filter((prop) => !prop.collapse && !prop.navOnly && typeof prop.path === 'string' && !prop.path.includes('#'))
      .map((prop, key) => {
        // Handle nested routes by using exact path matching
        if (prop.path === "/") {
          return <Route path={prop.path} element={prop.component} key={key} />;
        } else {
          // For nested routes like /merchants/owners/create, we need to handle the full path
          // Remove the leading slash to make it work with nested routing
          const routePath = prop.path.startsWith('/') ? prop.path.substring(1) : prop.path;
          return <Route path={routePath} element={prop.component} key={key} />;
        }
      });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < appRoutes.length; i++) {
      if (
        appRoutes[i].path &&
        path.indexOf(appRoutes[i].path) !== -1
      ) {
        return appRoutes[i].name;
      }
      if (appRoutes[i].views) {
        for (let j = 0; j < appRoutes[i].views.length; j++) {
          if (path.indexOf(appRoutes[i].views[j].path) !== -1) {
            return appRoutes[i].views[j].name;
          }
        }
      }
    }
    return "Main";
  };

  // toggles collapse between mini sidenav and normal
  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };

  const getNavbarTheme = () => {
    return "dark";
  };

  return (
    <ProtectedRoute>
      {/* COMENTADO - Solo usar token de Keycloak, no TokenProvider de Postman */}
      <ToastProvider>
        <Sidebar
          routes={getSidebarRoutes()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          logo={{
            innerLink: "/",
            imgSrc: require("assets/img/brand/nlf-logo.png"),
            imgAlt: "...",
          }}
          showDocs={false}
          showUserPanel={false}
        />
        {/* CONTENEDOR PRINCIPAL */}
        <div
          className="main-content d-flex flex-column min-vh-100"
          ref={mainContentRef}
        >
          <AdminNavbar
            theme={getNavbarTheme()}
            toggleSidenav={toggleSidenav}
            sidenavOpen={sidenavOpen}
            brandText={getBrandText(location.pathname)}
          />

          {/* CONTENIDO QUE CRECE */}
          <div className="flex-grow-1">
            <Routes>
              {getRoutes(appRoutes)}
              {/* Redirect to main menu for any unmatched routes */}
              <Route path="*" element={<Navigate to="/main-menu" replace />} />
            </Routes>
          </div>

          <AdminFooter />
        </div>
        {sidenavOpen ? (
          <div className="backdrop d-xl-none" onClick={toggleSidenav} />
        ) : null}
      </ToastProvider>
    </ProtectedRoute>
  );
}

export default User;
